<mat-card class="!gap-2 !rounded-2xl" [class]="customClass">
	<mat-card-content
		class="!py-4 !pt-4 lg:!py-6 lg:!pt-6"
		[ngClass]="{ '!pb-4 lg:!pb-6': !withoutBottomPadding, '!pb-0': withoutBottomPadding }"
	>
		<ng-content></ng-content>
	</mat-card-content>
</mat-card>
